import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { ThemeProvider } from '@emotion/react';
import RtkQueryInspector from './RtkQueryInspector.js';
import { reducer } from '../reducers.js';
import { createRtkQueryMonitorThemeFromBase16Theme, resolveBase16Theme, StyleUtilsContext, } from '../styles/themes.js';
class RtkQueryMonitor extends Component {
    render() {
        const { currentStateIndex, computedStates, monitorState, dispatch, actionsById, theme, invertTheme, } = this.props;
        const base16Theme = resolveBase16Theme(theme);
        const styleUtils = { base16Theme, invertTheme };
        const rtkQueryMonitorTheme = createRtkQueryMonitorThemeFromBase16Theme(base16Theme, invertTheme);
        return (_jsx(StyleUtilsContext.Provider, { value: styleUtils, children: _jsx(ThemeProvider, { theme: rtkQueryMonitorTheme, children: _jsx(RtkQueryInspector, { computedStates: computedStates, currentStateIndex: currentStateIndex, monitorState: monitorState, dispatch: dispatch, actionsById: actionsById }) }) }));
    }
}
RtkQueryMonitor.update = reducer;
RtkQueryMonitor.defaultProps = {
    theme: 'nicinabox',
    invertTheme: false,
};
export default RtkQueryMonitor;
